export const getLanguageFromLocal = () => {
  const ln = localStorage.getItem("i18nextLng");
  if (ln) return ln;
  return "gr";
};

export const firstLetterToUpperCase = (value: string) => {
  return value
    .split(" ")
    .map((el) => el.slice(0, 1).toUpperCase() + el.slice(1))
    .join(" ");
};

export const textCropping = (text: string, maxLength: number) => {
  if (text.length > maxLength) return text.slice(0, maxLength) + "...";
  return text;
};
